import React from 'react';
import { motion } from 'framer-motion';
import { color, radius, TOUCH } from '../tokens';

interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: React.ReactNode;
  /** Accessible label — required because the button has no text. */
  label: string;
  variant?: 'plain' | 'surface';
}

const tap = { scale: 0.92 };

/**
 * Square icon button with a guaranteed >=44px touch target (thumb-first).
 */
export default function IconButton({ children, label, variant = 'plain', disabled, style, ...rest }: IconButtonProps) {
  const s: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: TOUCH,
    height: TOUCH,
    flexShrink: 0,
    borderRadius: radius.sm,
    cursor: disabled ? 'not-allowed' : 'pointer',
    color: color.text,
    background: variant === 'surface' ? color.surfaceRaised : 'transparent',
    border: variant === 'surface' ? `1px solid ${color.border}` : '1px solid transparent',
    opacity: disabled ? 0.5 : 1,
    WebkitTapHighlightColor: 'transparent',
    ...style,
  };
  return (
    <motion.button
      {...(rest as object)}
      aria-label={label}
      title={label}
      whileTap={tap}
      disabled={disabled}
      style={s}
    >
      {children}
    </motion.button>
  );
}
